export const routeName = 'cookies';
export const slugs: Record<string, string> = {
	en: 'cookies',
	es: 'cookies',
	ca: 'cookies',
	it: 'cookies',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-02-24' };
